import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';

const _productName: string = Licensing.Products.Internal.MAS;
const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(_productName);

export const MAS_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: _productName,
	route: _baseUrl,
	sidenav: {
		productName: _productName,
		sections: [{
			items: [
				{
					display: 'Home',
					route: `${_baseUrl}`,
					icon: 'faHome',
					linkedRoutes: [
						`${_baseUrl}/home/author/overview`,
						`${_baseUrl}/home/author/completion`,
						`${_baseUrl}/home/author/approval`,
						`${_baseUrl}/home/author/marked-deletion`,
						`${_baseUrl}/home/author/marked-undeletion`,
						`${_baseUrl}/home/author/marked-publication`,
						`${_baseUrl}/home/author/checked-out`,
						`${_baseUrl}/home/approver/overview`,
						`${_baseUrl}/home/approver/completion`,
						`${_baseUrl}/home/approver/approval`,
						`${_baseUrl}/home/approver/marked-deletion`,
						`${_baseUrl}/home/approver/marked-undeletion`,
						`${_baseUrl}/home/approver/marked-publication`,
						`${_baseUrl}/home/approver/checked-out`,
						`${_baseUrl}/home/approver/blacklist`,
					]
				},
				{
					display: 'CVE Gap Detection',
					route: `${_baseUrl}/cve-gap-detection`,
					icon: 'faChartPie',
					children: [],
					linkedRoutes: [
						`${_baseUrl}/cve-gap-detection/overview`,
						`${_baseUrl}/cve-gap-detection/suppressions`,
						`${_baseUrl}/cve-gap-detection/product/:ProductId`,
					]
				},
				{
					display: 'Patching Metadata',
					route: '',
					icon: 'faCube',
					children: [
						{
							display: 'Software Products',
							route: `${_baseUrl}/authoring/software-products`,
						},
						{
							display: 'Software Icons',
							route: `${_baseUrl}/authoring/software-icons`,
						}
					],
					linkedRoutes: []
				},
				{
					display: 'Rules',
					route: `${_baseUrl}/authoring-rules`,
					icon: 'faArrowToRight',
				},
			]
		}]
	}
};
